import React from 'react'
import { Stepper } from 'react-form-stepper'

interface ATStepperProps {
  steps: { label: string }[]
  activeStep: number
}

const ATStepper = ({ steps, activeStep }: ATStepperProps) => {
  return (
    <Stepper
      steps={steps}
      activeStep={activeStep}
      connectorStateColors={true}
      connectorStyleConfig={{
        completedColor: '#114a6e',
        activeColor: '#114a6e',
        disabledColor: '#eee',
        size: 2,
        style: 'solid',
      }}
      styleConfig={{
        activeBgColor: '#114a6e',
        completedBgColor: '#114a6e',
        inactiveBgColor: '#eee',
        activeTextColor: '#fff',
        completedTextColor: '#fff',
        inactiveTextColor: '#444',
        size: 30,
        circleFontSize: 14,
        labelFontSize: 14,
        borderRadius: 50,
        fontWeight: 500,
      }}
    />
  )
}

export default ATStepper
